const LINK_RE = /\[([^\]]+)\]\((https?:\/\/[^)]+)\)|(https?:\/\/\S+)/g;

export function CommentBody({ text }: { text: string }) {
  const nodes: React.ReactNode[] = [];
  let last = 0;
  let m: RegExpExecArray | null;

  while ((m = LINK_RE.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[1] && m[2])
      nodes.push(<a key={m.index} href={m[2]} target="_blank" rel="noreferrer" className="text-blue-600 underline">{m[1]}</a>);
    else
      nodes.push(<a key={m.index} href={m[3]} target="_blank" rel="noreferrer" className="break-all text-blue-600 underline">{m[3]}</a>);
    last = m.index + m[0].length;
  }

  if (last < text.length) nodes.push(text.slice(last));
  return <>{nodes}</>;
}
